export default __webpack_public_path__ + "static/media/vid.2a3517e3.mp4";